import React from "react";

/**
 * Bloc lisible obligatoire pour texte sur fond photo — style bleu ciel GolfMAP.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {string} [props.testId]
 * @param {'default'|'compact'|'hero'|'info'|'warning'} [props.variant]
 * @param {keyof JSX.IntrinsicElements} [props.as]
 */
export function GsdReadableBlock({
  children,
  className = "",
  testId = "gsd-readable-block",
  variant = "default",
  as: Tag = "div",
}) {
  return (
    <Tag
      className={`gsd-readable-block gsd-readable-block--${variant}${className ? ` ${className}` : ""}`}
      data-testid={testId}
      data-gsd-readable-block="true"
    >
      {children}
    </Tag>
  );
}

/** Alias sémantique — contenu de page dans bloc lisible. */
export function GsdContentBlock(props) {
  return <GsdReadableBlock {...props} testId={props.testId || "gsd-content-block"} className={`gsd-content-block ${props.className || ""}`.trim()} />;
}

/**
 * Panneau info / avertissement dans bloc lisible.
 * @param {object} props
 * @param {string} [props.title]
 * @param {React.ReactNode} props.children
 * @param {'info'|'warning'} [props.tone]
 * @param {string} [props.testId]
 */
export function GsdInfoPanel({ title, children, tone = "info", testId = "gsd-info-panel", className = "" }) {
  return (
    <GsdReadableBlock variant={tone} testId={testId} className={`gsd-info-panel ${className}`.trim()}>
      {title ? <p className="gsd-info-panel__title">{title}</p> : null}
      <div className="gsd-info-panel__body">{children}</div>
    </GsdReadableBlock>
  );
}

/**
 * Hero sur fond photo — tout le texte dans bloc bleu ciel.
 * @param {object} props
 * @param {string} [props.kicker]
 * @param {string} [props.title]
 * @param {string} [props.lead]
 * @param {React.ReactNode} [props.children]
 * @param {React.ReactNode} [props.aside]
 * @param {React.ReactNode} [props.actions]
 * @param {string} [props.testId]
 */
export function GsdHeroBlock({ kicker, title, lead, children, aside, actions, testId = "gsd-hero-block", className = "" }) {
  return (
    <GsdReadableBlock variant="hero" testId={testId} className={`gsd-hero-block ${className}`.trim()}>
      <div className="gsd-hero-block__grid">
        <div className="gsd-hero-block__main">
          {kicker ? <p className="gsd-hero-block__kicker">{kicker}</p> : null}
          {title ? <h1 className="gsd-hero-block__title">{title}</h1> : null}
          {lead ? <p className="gsd-hero-block__lead">{lead}</p> : null}
          {children}
          {actions ? <div className="gsd-hero-block__actions">{actions}</div> : null}
        </div>
        {aside ? <aside className="gsd-hero-block__aside">{aside}</aside> : null}
      </div>
    </GsdReadableBlock>
  );
}
